<script>
export default {
    props: {
        active: {type: Boolean, default: false},
    },

    computed: {
        css() {
            return this.active ? 'far fa-eye-slash' : 'far fa-eye'
        }
    }
}
</script>

<template>
  <button class="btn btn-sm navbar-btn btn-secondary me-1 mb-1"
  v-b-tooltip.hover title="Zeige Standbesuche"
   @click.prevent="$emit('click')">
       <i :class="css"></i>
  </button>
</template>
